import React from "react";

export const SuzukiResult = ({ result, formatCurrency, calcPercent }) => {
  const rows = [];
  if (result.sale_category !== "VD") rows.push(["base", "Marge de base", result.base_margin]);
  if (result.sale_category === "SOCIETE") rows.push(["company", `Participation Suzuki ${result.company_type}`, result.company_aid]);
  else {
    if (result.vd_aid > 0) rows.push(["vd", "Aide VD", result.vd_aid]);
    if (result.vdr_aid > 0) rows.push(["vk", "Aide VK", result.vdr_aid]);
    rows.push(["participation", "Participation Suzuki France", result.suzuki_participation]);
    if (result.suzuki_booster_ht > 0) rows.push(["booster", "Participation Booster automatique", result.suzuki_booster_ht]);
  }
  if (result.exceptional_aid > 0) rows.push(["exceptional", "Aide exceptionnelle", result.exceptional_aid]);
  return rows.map(([key, label, amount]) => <div key={key} data-testid={`suzuki-result-${key}-row`} className="flex flex-wrap justify-between gap-2">
    <span>{label}</span><span data-testid={`suzuki-result-${key}-amount`} className="font-data">{formatCurrency(amount)} <span className="text-xs text-muted-foreground">{calcPercent(amount)}</span></span>
  </div>);
};